export const ADMIN_CASES_FAILURE = "@@admin/ADMIN_CASES_FAILURE";
export const ADMIN_CASES_REQUEST = "@@admin/ADMIN_CASES_REQUEST";
export const ADMIN_CASES_SUCCESS = "@@admin/ADMIN_CASES_SUCCESS";

export const ADMIN_CASE_FAILURE = "@@admin/ADMIN_CASE_FAILURE";
export const ADMIN_CASE_REQUEST = "@@admin/ADMIN_CASE_REQUEST";
export const ADMIN_CASE_SUCCESS = "@@admin/ADMIN_CASE_SUCCESS";

export const ADMIN_SLIDE_FAILURE = "@@admin/ADMIN_SLIDE_FAILURE";
export const ADMIN_SLIDE_REQUEST = "@@admin/ADMIN_SLIDE_REQUEST";
export const ADMIN_SLIDE_SUCCESS = "@@admin/ADMIN_SLIDE_SUCCESS";

export const ADMIN_UPDATE_CASE_FAILURE = "@@admin/ADMIN_UPDATE_CASE_FAILURE";
export const ADMIN_UPDATE_CASE_REQUEST = "@@admin/ADMIN_UPDATE_CASE_REQUEST";
export const ADMIN_UPDATE_CASE_SUCCESS = "@@admin/ADMIN_UPDATE_CASE_SUCCESS";

export const ADMIN_DELETE_CASE_REQUEST = "@@admin/ADMIN_DELETE_CASE_REQUEST";
export const ADMIN_DELETE_CASE_SUCCESS = "@@admin/ADMIN_DELETE_CASE_SUCCESS";
export const ADMIN_DELETE_CASE_FAILURE = "@@admin/ADMIN_DELETE_CASE_FAILURE";

export const ADMIN_RESET_ERROR_MESSAGE = "@@admin/ADMIN_RESET_ERROR_MESSAGE";
export const ADMIN_RESET_DELETION_STATUS =
  "@@admin/ADMIN_RESET_DELETION_STATUS";

export const ADMIN_UPDATE_PATIENT_REQUEST =
  "@@admin/ADMIN_UPDATE_PATIENT_REQUEST";
export const ADMIN_UPDATE_PATIENT_SUCCESS =
  "@@admin/ADMIN_UPDATE_PATIENT_SUCCESS";
export const ADMIN_UPDATE_PATIENT_FAILURE =
  "@@admin/ADMIN_UPDATE_PATIENT_FAILURE";

export const ADMIN_SLIDES_REQUEST = "@@admin/ADMIN_SLIDES_REQUEST";
export const ADMIN_SLIDES_FAILURE = "@@admin/ADMIN_SLIDES_FAILURE";
export const ADMIN_SLIDES_SUCCESS = "@@admin/ADMIN_SLIDES_SUCCESS";

export const ADMIN_SLIDE_SET = "@@admin/ADMIN_SLIDE_SET";

export const ADMIN_SLIDE_BARCODE_REQUEST =
  "@@admin/ADMIN_SLIDE_BARCODE_REQUEST";
export const ADMIN_SLIDE_BARCODE_SUCCESS =
  "@@admin/ADMIN_SLIDE_BARCODE_SUCCESS";
export const ADMIN_SLIDE_BARCODE_FAILURE =
  "@@admin/ADMIN_SLIDE_BARCODE_FAILURE";
export const ADMIN_SLIDE_BARCODE_SET = "@@admin/ADMIN_SLIDE_BARCODE_SET";

export const ADMIN_SLIDE_MACRO_REQUEST = "@@admin/ADMIN_SLIDE_MACRO_REQUEST";
export const ADMIN_SLIDE_MACRO_SUCCESS = "@@admin/ADMIN_SLIDE_MACRO_SUCCESS";
export const ADMIN_SLIDE_MACRO_FAILURE = "@@admin/ADMIN_SLIDE_MACRO_FAILURE";
export const ADMIN_SLIDE_MACRO_SET = "@@admin/ADMIN_SLIDE_MACRO_SET";

export const ADMIN_UPDATE_SLIDE_REQUEST = "@@admin/ADMIN_UPDATE_SLIDE_REQUEST";
export const ADMIN_UPDATE_SLIDE_SUCCESS = "@@admin/ADMIN_UPDATE_SLIDE_SUCCESS";
export const ADMIN_UPDATE_SLIDE_FAILURE = "@@admin/ADMIN_UPDATE_SLIDE_FAILURE";
export const ADMIN_UPDATE_SLIDE_CASES_FAILURE =
  "@@admin/ADMIN_UPDATE_SLIDE_CASES_FAILURE";

export const ADMIN_DELETE_SLIDE_REQUEST = "@@admin/ADMIN_DELETE_SLIDE_REQUEST";
export const ADMIN_DELETE_SLIDE_SUCCESS = "@@admin/ADMIN_DELETE_SLIDE_SUCCESS";
export const ADMIN_DELETE_SLIDE_FAILURE = "@@admin/ADMIN_DELETE_SLIDE_FAILURE";

export const ADMIN_UPDATE_SPECIMEN_REQUEST =
  "@@admin/ADMIN_UPDATE_SPECIMEN_REQUEST";
export const ADMIN_UPDATE_SPECIMEN_SUCCESS =
  "@@admin/ADMIN_UPDATE_SPECIMEN_SUCCESS";
export const ADMIN_UPDATE_SPECIMEN_FAILURE =
  "@@admin/ADMIN_UPDATE_SPECIMEN_FAILURE";

export const ADMIN_DELETE_SPECIMEN_REQUEST =
  "@@admin/ADMIN_DELETE_SPECIMEN_REQUEST";
export const ADMIN_DELETE_SPECIMEN_SUCCESS =
  "@@admin/ADMIN_DELETE_SPECIMEN_SUCCESS";
export const ADMIN_DELETE_SPECIMEN_FAILURE =
  "@@admin/ADMIN_DELETE_SPECIMEN_FAILURE";

export const ADMIN_SLIDES_ACTION_RESET = "@@admin/ADMIN_SLIDES_ACTION_RESET";
export const ADMIN_SLIDES_RUN_ACTION_REQUEST =
  "@@admin/ADMIN_SLIDES_RUN_ACTION_REQUEST";
export const ADMIN_SLIDES_RUN_ACTION_SUCCESS =
  "@@admin/ADMIN_SLIDES_RUN_ACTION_SUCCESS";
export const ADMIN_SLIDES_RUN_ACTION_FAILURE =
  "@@admin/ADMIN_SLIDES_RUN_ACTION_FAILURE";

export const ADMIN_CASE_DOCUMENTS_LIST_REQUEST =
  "@@admin/ADMIN_CASE_DOCUMENTS_LIST_REQUEST";
export const ADMIN_CASE_DOCUMENTS_LIST_SUCCESS =
  "@@admin/ADMIN_CASE_DOCUMENTS_LIST_SUCCESS";
export const ADMIN_CASE_DOCUMENTS_LIST_FAILURE =
  "@@admin/ADMIN_CASE_DOCUMENTS_LIST_FAILURE";

export const ADMIN_SET_CASE_DOCUMENT = "@@admin/ADMIN_SET_CASE_DOCUMENT";
export const ADMIN_OPEN_CASE_DOCUMENT = "@@admin/ADMIN_OPEN_CASE_DOCUMENT";
export const ADMIN_CASE_DOCUMENT_FAILURE =
  "@@admin/ADMIN_CASE_DOCUMENT_FAILURE";
export const ADMIN_CASE_DOCUMENT_SUCCESS =
  "@@admin/ADMIN_CASE_DOCUMENT_SUCCESS";
export const ADMIN_CASE_DOCUMENT_REQUEST =
  "@@admin/ADMIN_CASE_DOCUMENT_REQUEST";

export const ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS =
  "@@admin/ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS";
export const ADMIN_UPDATE_CASE_DOCUMENT_FAILURE =
  "@@admin/ADMIN_UPDATE_CASE_DOCUMENT_FAILURE";
export const ADMIN_UPDATE_CASE_DOCUMENT_REQUEST =
  "@@admin/ADMIN_UPDATE_CASE_DOCUMENT_REQUEST";

export const ADMIN_UPLOAD_CASE_DOCUMENT_SUCCESS =
  "@@admin/ADMIN_UPLOAD_CASE_DOCUMENT_SUCCESS";
export const ADMIN_UPLOAD_CASE_DOCUMENT_FAILURE =
  "@@admin/ADMIN_UPLOAD_CASE_DOCUMENT_FAILURE";
export const ADMIN_UPLOAD_CASE_DOCUMENT_REQUEST =
  "@@admin/ADMIN_UPLOAD_CASE_DOCUMENT_REQUEST";

export const ADMIN_DELETE_CASE_DOCUMENT_SUCCESS =
  "@@admin/ADMIN_DELETE_CASE_DOCUMENT_SUCCESS";
export const ADMIN_DELETE_CASE_DOCUMENT_FAILURE =
  "@@admin/ADMIN_DELETE_CASE_DOCUMENT_FAILURE";
export const ADMIN_DELETE_CASE_DOCUMENT_REQUEST =
  "@@admin/ADMIN_DELETE_CASE_DOCUMENT_REQUEST";

export const SET_LAST_ADMIN_CASE_VIEWED = "@@admin/SET_LAST_ADMIN_CASE_VIEWED";

export const SET_LAST_ADMIN_SLIDE_VIEWED =
  "@@admin/SET_LAST_ADMIN_SLIDE_VIEWED";

export const ADMIN_UPDATE_INSURANCE_SUCCESS =
  "@@admin/ADMIN_UPDATE_INSURANCE_SUCCESS";
export const ADMIN_UPDATE_INSURANCE_FAILURE =
  "@@admin/ADMIN_UPDATE_INSURANCE_FAILURE";
export const ADMIN_UPDATE_INSURANCE_REQUEST =
  "@@admin/ADMIN_UPDATE_INSURANCE_REQUEST";

export const ADMIN_CREATE_INSURANCE_SUCCESS =
  "@@admin/ADMIN_CREATE_INSURANCE_SUCCESS";
export const ADMIN_CREATE_INSURANCE_FAILURE =
  "@@admin/ADMIN_CREATE_INSURANCE_FAILURE";
export const ADMIN_CREATE_INSURANCE_REQUEST =
  "@@admin/ADMIN_CREATE_INSURANCE_REQUEST";

export const ADMIN_UPDATE_PATIENT_LOCATION_SUCCESS =
  "@@admin/ADMIN_UPDATE_PATIENT_LOCATION_SUCCESS";
export const ADMIN_UPDATE_PATIENT_LOCATION_FAILURE =
  "@@admin/ADMIN_UPDATE_PATIENT_LOCATION_FAILURE";
export const ADMIN_UPDATE_PATIENT_LOCATION_REQUEST =
  "@@admin/ADMIN_UPDATE_PATIENT_LOCATION_REQUEST";

export const ADMIN_UPDATE_PATIENT_GUARANTOR_SUCCESS =
  "@@admin/ADMIN_UPDATE_PATIENT_GUARANTOR_SUCCESS";
export const ADMIN_UPDATE_PATIENT_GUARANTOR_FAILURE =
  "@@admin/ADMIN_UPDATE_PATIENT_GUARANTOR_FAILURE";
export const ADMIN_UPDATE_PATIENT_GUARANTOR_REQUEST =
  "@@admin/ADMIN_UPDATE_PATIENT_GUARANTOR_REQUEST";

export const ADMIN_CREATE_PATIENT_GUARANTOR_SUCCESS =
  "@@admin/ADMIN_CREATE_PATIENT_GUARANTOR_SUCCESS";
export const ADMIN_CREATE_PATIENT_GUARANTOR_FAILURE =
  "@@admin/ADMIN_CREATE_PATIENT_GUARANTOR_FAILURE";
export const ADMIN_CREATE_PATIENT_GUARANTOR_REQUEST =
  "@@admin/ADMIN_CREATE_PATIENT_GUARANTOR_REQUEST";

export const ADMIN_DELETE_INSURANCE_SUCCESS =
  "@@admin/ADMIN_DELETE_INSURANCE_SUCCESS";
export const ADMIN_DELETE_INSURANCE_FAILURE =
  "@@admin/ADMIN_DELETE_INSURANCE_FAILURE";
export const ADMIN_DELETE_INSURANCE_REQUEST =
  "@@admin/ADMIN_DELETE_INSURANCE_REQUEST";

export const ADMIN_WORK_PROCESSES_SUCCESS =
  "@@admin/ADMIN_WORK_PROCESSES_SUCCESS";
export const ADMIN_WORK_PROCESSES_FAILURE =
  "@@admin/ADMIN_WORK_PROCESSES_FAILURE";
export const ADMIN_WORK_PROCESSES_REQUEST =
  "@@admin/ADMIN_WORK_PROCESSES_REQUEST";

export const ADMIN_CREATE_QAREVIEW_SUCCESS =
  "@@admin/ADMIN_CREATE_QAREVIEW_SUCCESS";
export const ADMIN_CREATE_QAREVIEW_FAILURE =
  "@@admin/ADMIN_CREATE_QAREVIEW_FAILURE";
export const ADMIN_CREATE_QAREVIEW_REQUEST =
  "@@admin/ADMIN_CREATE_QAREVIEW_REQUEST";

export const ADMIN_UPDATE_QAREVIEW_SUCCESS =
  "@@admin/ADMIN_UPDATE_QAREVIEW_SUCCESS";
export const ADMIN_UPDATE_QAREVIEW_FAILURE =
  "@@admin/ADMIN_UPDATE_QAREVIEW_FAILURE";
export const ADMIN_UPDATE_QAREVIEW_REQUEST =
  "@@admin/ADMIN_UPDATE_QAREVIEW_REQUEST";

export const ADMIN_UPDATE_INTEGRATIONS_REQUEST =
  "@@admin/ADMIN_UPDATE_INTEGRATIONS_REQUEST";
export const ADMIN_UPDATE_INTEGRATIONS_SUCCESS =
  "@@admin/ADMIN_UPDATE_INTEGRATIONS_SUCCESS";
export const ADMIN_UPDATE_INTEGRATIONS_FAILURE =
  "@@admin/ADMIN_UPDATE_INTEGRATIONS_FAILURE";

export const BULK_UPDATE_CASES_SUCCESS = "@@admin/BULK_UPDATE_CASES_SUCCESS";
export const BULK_UPDATE_CASES_REQUEST = "@@admin/BULK_UPDATE_CASES_REQUEST";
export const BULK_UPDATE_CASES_FAILURE = "@@admin/BULK_UPDATE_CASES_FAILURE";

export const TOGGLE_BULK_COLUMNS = "@@admin/TOGGLE_BULK_COLUMNS";

export const ADMIN_REASSIGN_ACCESSION_NUMBER_REQUEST =
  "@@admin/ADMIN_REASSIGN_ACCESSION_NUMBER_REQUEST";
export const ADMIN_REASSIGN_ACCESSION_NUMBER_SUCCESS =
  "@@admin/ADMIN_REASSIGN_ACCESSION_NUMBER_SUCCESS";
export const ADMIN_REASSIGN_ACCESSION_NUMBER_FAILURE =
  "@@admin/ADMIN_REASSIGN_ACCESSION_NUMBER_FAILURE";
